import { createStackNavigator } from "@react-navigation/stack";
import React from "react";
import { useTranslation } from "react-i18next";
import AddProblem from "./AddProblem";
import Agenda from "./Agenda";
import HistoryEvent from "./HistoryEvent";
import TodoBooking from "./TodoBooking";
import EditHistoryEvent from "./EditHistoryEvent";

const Stack = createStackNavigator();

const AgendaStack = () => {
    const { t, i18n } = useTranslation();
    return (
        <Stack.Navigator>
            <Stack.Screen
                name="AgendaScreen"
                component={Agenda}
                options={{
                    title: t("HEADER_AGENDA"),
                    headerStyle: {
                        backgroundColor: "#D71D9A",
                    },
                    headerTintColor: "#fff",
                    headerTitleStyle: {
                        fontWeight: "bold",
                    }
                }}
            />
            <Stack.Screen
                name="TodoScreen"
                component={TodoBooking}
                options={{
                    title: t("HEADER_AGENDA"),
                    headerStyle: {
                        backgroundColor: "#D71D9A",
                    },
                    headerTintColor: "#fff",
                    headerTitleStyle: {
                        fontWeight: "bold",
                    },
                }}
            />
            <Stack.Screen
                name="AddProblem"
                component={AddProblem}
                options={{
                    title: t("HEADER_PROBLEM"),
                    headerStyle: {
                        backgroundColor: "#D71D9A",
                    },
                    headerTintColor: "#fff",
                    headerTitleStyle: {
                        fontWeight: "bold",
                    },
                }}
            />
            <Stack.Screen
                name="HistoryEvent"
                component={HistoryEvent}
                options={{
                    title: t("HEADER_HISTORY"),
                    headerStyle: {
                        backgroundColor: "#D71D9A",
                    },
                    headerTintColor: "#fff",
                    headerTitleStyle: {
                        fontWeight: "bold",
                    },
                }}
            />
            <Stack.Screen
                name="EditHistoryEvent"
                component={EditHistoryEvent}
                options={{
                    title: t("HEADER_HISTORY"),
                    headerStyle: {
                        backgroundColor: "#D71D9A",
                    },
                    headerTintColor: "#fff",
                    headerTitleStyle: {
                        fontWeight: "bold",
                    },
                }}
            />
        </Stack.Navigator>
    );
}

export default AgendaStack;